export const formatPoint = (number) => {
  return number && Intl.NumberFormat('ja-JP').format(number);
};
